import PubSub from "underpub-js";
import Immerser from 'immerser';

var NavBar = function(options) {

	this.options = {
		$el: false,
		baseClass: 'el-NavBar',
	};

	$.extend(true, this.options, options);

};

NavBar.prototype.init = function() {

	var self = this;

	// this.$hamburger = this.options.$el.find(`.${self.options.baseClass}__hamburger`);

	this.options.$el.on('click', `.${self.options.baseClass}__hamburger`, function() {

		PubSub.publish('NavOverlay:show');
		PubSub.publish('NavOverlay:opening');
		
	});

	PubSub.subscribe('NavOverlay:closing', function() {

		self.hamburgerNavClosed();

	});

	PubSub.subscribe('NavOverlay:opening', function() {

		self.hamburgerNavOpen();

	});

	// immerser
	
	this.immerserInstance = new Immerser({});

	// this fixes a bug in some browsers where initing the immerser instance in window.load wasn't working because window.onload was
	// firing before document.load.
	// This block will never be called if window.load fires before document.load, but if window.load fires after document.load, this
	// makes sure our immerser states are correct.
	$(window).on('load', function() {
		self.immerserInstance.handleResize();
	});
	


	// update hamburger color on load/scroll
	// this.updateHamburgerColor();

	// PubSub.subscribe('scroll', function() {
	// 	self.updateHamburgerColor();
	// });

};

// this function checks if the hamburger is over a component that needs it to be a color other than white,
//and sets the color accordingly
// NavBar.prototype.updateHamburgerColor = function() {

// 	var self = this;

// 	var hamburgerTop = this.$hamburger.offset().top;
// 	var hamburgerBottom = this.$hamburger.offset().top + this.$hamburger.height();

// 	self.$hamburger
// 		.removeClass('el-NavBar__hamburger--red')
// 		.removeClass('el-NavBar__hamburger--black')
// 		.removeClass('el-NavBar__hamburger--hidden');

// 	$('.hamburger-black, .hamburger-red, .comp-Footer').each(function() {

// 		var top = $(this).offset().top;
// 		var bottom = $(this).offset().top + $(this).outerHeight();

// 		if (
// 			hamburgerBottom >= top && hamburgerTop <= bottom
// 		)
// 		{
		
// 			if ($(this).hasClass('hamburger-black'))
// 			{
// 				self.$hamburger.addClass('el-NavBar__hamburger--black');
// 			}

// 			else if ($(this).hasClass('hamburger-red'))
// 			{
// 				self.$hamburger.addClass('el-NavBar__hamburger--red');
// 			}

// 			return;

// 		}

// 	});

// };

NavBar.prototype.hamburgerNavOpen = function() {

	var self = this;

	self.options.$el.find(`.${self.options.baseClass}__hamburger`).addClass(`${self.options.baseClass}__hamburger--closed`);

};

NavBar.prototype.hamburgerNavClosed = function() {

	var self = this;

	self.options.$el.find(`.${self.options.baseClass}__hamburger`).removeClass(`${self.options.baseClass}__hamburger--closed`);

};

export default NavBar;
